import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrandheroWorkspaceDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 420 371",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_252_2411)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M369.1 187.2C379.4 210.8 389.9 234.5 403.6 256.5C408 263.5 412.8 270.8 412.6 279.1C412.6 282 411.7 285 409.9 287.3C405.1 293.4 395.6 295.2 388.3 294.2C377.4 292.7 374.6 285.5 372.7 275.7C370.2 262.9 367.5 250.1 363.7 237.6C358.5 220.8 352.7 205.8 359.9 188.4C360.5 187 361.1 185.6 362.3 184.7C365 182.7 367.5 185.2 369.1 187.2Z",
				fill: "#1c70e8",
				stroke: "#001321",
				strokeWidth: 4,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M406 290.7C400.9 294 393.9 294.9 388.3 294.1C377.4 292.6 374.6 285.4 372.7 275.6C370.3 262.8 367.5 250 363.7 237.5C358.5 220.7 352.7 205.7 359.9 188.3C360.5 186.9 361.1 185.5 362.3 184.6C365 182.6 367.5 185.1 369.1 187.1C370.9 191.3 372.7 195.5 374.6 199.7C374.1 211.2 378 222.2 381.7 234.1C385.6 246.6 388.3 259.4 390.7 272.2C392.6 281.9 395.3 289 405.9 290.7H406Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M390.9 254.8C394.7 260.6 400 269.6 398.4 276.8C396.7 282.3 389.8 281.7 386.2 278.8L386.3 278.4C387.1 278.3 387.8 278.3 388.5 278.2C390.1 278 392.5 277.8 393.5 276.9C396.8 273.4 394.5 267.2 393.4 263.1C392.6 260.4 391.6 257.7 390.5 255.1L390.8 254.9L390.9 254.8Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 211.9C2.3 211.9 1 210.6 1 208.9V55.8H216.3V208.9C216.3 210.6 215 211.9 213.3 211.9H4Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M215.3 56.8V208.9C215.3 210 214.4 210.9 213.3 210.9H4C2.9 210.9 2 210 2 208.9V56.8H215.3ZM217.3 54.8H0V208.9C0 211.1 1.8 212.9 4 212.9H213.3C215.5 212.9 217.3 211.1 217.3 208.9V54.8Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1 57.7999V22.5999C1 21.3999 2 20.3999 3.2 20.3999H214C215.2 20.3999 216.2 21.3999 216.2 22.5999V57.7999H1Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M214.1 21.3999C214.8 21.3999 215.3 21.9999 215.3 22.5999V56.7999H2V22.5999C2 21.8999 2.6 21.3999 3.2 21.3999H214M214.1 19.3999H3.2C1.4 19.3999 0 20.7999 0 22.5999V58.7999H217.3V22.5999C217.3 20.7999 215.9 19.3999 214.1 19.3999Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31 0H30.9C28.8013 0 27.1 1.70132 27.1 3.8V31.2C27.1 33.2987 28.8013 35 30.9 35H31C33.0987 35 34.8 33.2987 34.8 31.2V3.8C34.8 1.70132 33.0987 0 31 0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83.3 0H83.2C81.1013 0 79.4 1.70132 79.4 3.8V31.2C79.4 33.2987 81.1013 35 83.2 35H83.3C85.3987 35 87.1 33.2987 87.1 31.2V3.8C87.1 1.70132 85.3987 0 83.3 0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M135.3 0H135.2C133.101 0 131.4 1.70132 131.4 3.8V31.2C131.4 33.2987 133.101 35 135.2 35H135.3C137.399 35 139.1 33.2987 139.1 31.2V3.8C139.1 1.70132 137.399 0 135.3 0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M187.3 0H187.2C185.101 0 183.4 1.70132 183.4 3.8V31.2C183.4 33.2987 185.101 35 187.2 35H187.3C189.399 35 191.1 33.2987 191.1 31.2V3.8C191.1 1.70132 189.399 0 187.3 0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.9 85.3H17C15.9506 85.3 15.1 86.1507 15.1 87.2V103.1C15.1 104.149 15.9506 105 17 105H32.9C33.9493 105 34.8 104.149 34.8 103.1V87.2C34.8 86.1507 33.9493 85.3 32.9 85.3Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.9 85.3H45C43.9506 85.3 43.1 86.1507 43.1 87.2V103.1C43.1 104.149 43.9506 105 45 105H60.9C61.9493 105 62.8 104.149 62.8 103.1V87.2C62.8 86.1507 61.9493 85.3 60.9 85.3Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M88.8 85.3H72.9C71.8507 85.3 71 86.1507 71 87.2V103.1C71 104.149 71.8507 105 72.9 105H88.8C89.8493 105 90.7 104.149 90.7 103.1V87.2C90.7 86.1507 89.8493 85.3 88.8 85.3Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M116.8 85.3H100.9C99.8507 85.3 99 86.1507 99 87.2V103.1C99 104.149 99.8507 105 100.9 105H116.8C117.849 105 118.7 104.149 118.7 103.1V87.2C118.7 86.1507 117.849 85.3 116.8 85.3Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M144.8 85.3H128.9C127.851 85.3 127 86.1507 127 87.2V103.1C127 104.149 127.851 105 128.9 105H144.8C145.849 105 146.7 104.149 146.7 103.1V87.2C146.7 86.1507 145.849 85.3 144.8 85.3Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M172.8 85.3H156.9C155.851 85.3 155 86.1507 155 87.2V103.1C155 104.149 155.851 105 156.9 105H172.8C173.849 105 174.7 104.149 174.7 103.1V87.2C174.7 86.1507 173.849 85.3 172.8 85.3Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M200.7 85.3H184.8C183.751 85.3 182.9 86.1507 182.9 87.2V103.1C182.9 104.149 183.751 105 184.8 105H200.7C201.749 105 202.6 104.149 202.6 103.1V87.2C202.6 86.1507 201.749 85.3 200.7 85.3Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.9 114.2H17C15.9506 114.2 15.1 115.051 15.1 116.1V132C15.1 133.049 15.9506 133.9 17 133.9H32.9C33.9493 133.9 34.8 133.049 34.8 132V116.1C34.8 115.051 33.9493 114.2 32.9 114.2Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.9 114.2H45C43.9506 114.2 43.1 115.051 43.1 116.1V132C43.1 133.049 43.9506 133.9 45 133.9H60.9C61.9493 133.9 62.8 133.049 62.8 132V116.1C62.8 115.051 61.9493 114.2 60.9 114.2Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M88.8 114.2H72.9C71.8507 114.2 71 115.051 71 116.1V132C71 133.049 71.8507 133.9 72.9 133.9H88.8C89.8493 133.9 90.7 133.049 90.7 132V116.1C90.7 115.051 89.8493 114.2 88.8 114.2Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M116.8 114.2H100.9C99.8507 114.2 99 115.051 99 116.1V132C99 133.049 99.8507 133.9 100.9 133.9H116.8C117.849 133.9 118.7 133.049 118.7 132V116.1C118.7 115.051 117.849 114.2 116.8 114.2Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M144.8 114.2H128.9C127.851 114.2 127 115.051 127 116.1V132C127 133.049 127.851 133.9 128.9 133.9H144.8C145.849 133.9 146.7 133.049 146.7 132V116.1C146.7 115.051 145.849 114.2 144.8 114.2Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M172.8 114.2H156.9C155.851 114.2 155 115.051 155 116.1V132C155 133.049 155.851 133.9 156.9 133.9H172.8C173.849 133.9 174.7 133.049 174.7 132V116.1C174.7 115.051 173.849 114.2 172.8 114.2Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M200.7 114.2H184.8C183.751 114.2 182.9 115.051 182.9 116.1V132C182.9 133.049 183.751 133.9 184.8 133.9H200.7C201.749 133.9 202.6 133.049 202.6 132V116.1C202.6 115.051 201.749 114.2 200.7 114.2Z",
				fill: "#EC1C24"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.9 143H17C15.9506 143 15.1 143.851 15.1 144.9V160.8C15.1 161.849 15.9506 162.7 17 162.7H32.9C33.9493 162.7 34.8 161.849 34.8 160.8V144.9C34.8 143.851 33.9493 143 32.9 143Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.9 143H45C43.9506 143 43.1 143.851 43.1 144.9V160.8C43.1 161.849 43.9506 162.7 45 162.7H60.9C61.9493 162.7 62.8 161.849 62.8 160.8V144.9C62.8 143.851 61.9493 143 60.9 143Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M88.8 143H72.9C71.8507 143 71 143.851 71 144.9V160.8C71 161.849 71.8507 162.7 72.9 162.7H88.8C89.8493 162.7 90.7 161.849 90.7 160.8V144.9C90.7 143.851 89.8493 143 88.8 143Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M116.8 143H100.9C99.8507 143 99 143.851 99 144.9V160.8C99 161.849 99.8507 162.7 100.9 162.7H116.8C117.849 162.7 118.7 161.849 118.7 160.8V144.9C118.7 143.851 117.849 143 116.8 143Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M144.8 143H128.9C127.851 143 127 143.851 127 144.9V160.8C127 161.849 127.851 162.7 128.9 162.7H144.8C145.849 162.7 146.7 161.849 146.7 160.8V144.9C146.7 143.851 145.849 143 144.8 143Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M172.8 143H156.9C155.851 143 155 143.851 155 144.9V160.8C155 161.849 155.851 162.7 156.9 162.7H172.8C173.849 162.7 174.7 161.849 174.7 160.8V144.9C174.7 143.851 173.849 143 172.8 143Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M200.7 143H184.8C183.751 143 182.9 143.851 182.9 144.9V160.8C182.9 161.849 183.751 162.7 184.8 162.7H200.7C201.749 162.7 202.6 161.849 202.6 160.8V144.9C202.6 143.851 201.749 143 200.7 143Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.9 171.8H17C15.9506 171.8 15.1 172.651 15.1 173.7V189.6C15.1 190.649 15.9506 191.5 17 191.5H32.9C33.9493 191.5 34.8 190.649 34.8 189.6V173.7C34.8 172.651 33.9493 171.8 32.9 171.8Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.9 171.8H45C43.9506 171.8 43.1 172.651 43.1 173.7V189.6C43.1 190.649 43.9506 191.5 45 191.5H60.9C61.9493 191.5 62.8 190.649 62.8 189.6V173.7C62.8 172.651 61.9493 171.8 60.9 171.8Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M88.8 171.8H72.9C71.8507 171.8 71 172.651 71 173.7V189.6C71 190.649 71.8507 191.5 72.9 191.5H88.8C89.8493 191.5 90.7 190.649 90.7 189.6V173.7C90.7 172.651 89.8493 171.8 88.8 171.8Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M116.8 171.8H100.9C99.8507 171.8 99 172.651 99 173.7V189.6C99 190.649 99.8507 191.5 100.9 191.5H116.8C117.849 191.5 118.7 190.649 118.7 189.6V173.7C118.7 172.651 117.849 171.8 116.8 171.8Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M144.8 171.8H128.9C127.851 171.8 127 172.651 127 173.7V189.6C127 190.649 127.851 191.5 128.9 191.5H144.8C145.849 191.5 146.7 190.649 146.7 189.6V173.7C146.7 172.651 145.849 171.8 144.8 171.8Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M172.8 171.8H156.9C155.851 171.8 155 172.651 155 173.7V189.6C155 190.649 155.851 191.5 156.9 191.5H172.8C173.849 191.5 174.7 190.649 174.7 189.6V173.7C174.7 172.651 173.849 171.8 172.8 171.8Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M200.7 171.8H184.8C183.751 171.8 182.9 172.651 182.9 173.7V189.6C182.9 190.649 183.751 191.5 184.8 191.5H200.7C201.749 191.5 202.6 190.649 202.6 189.6V173.7C202.6 172.651 201.749 171.8 200.7 171.8Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1 85.3L34.2 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.9 85.3L14.8 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.5 85.3L62.6 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M62.3 85.3L43.2 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M71.5 85.3L90.6 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M90.3 85.3L71.2 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M99.3999 85.3L118.5 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M118.2 85.3L99.2 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M126.7 85.3L145.8 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M145.5 85.3L126.5 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1 114.4L34.2 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.9 114.4L14.8 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.5 114.4L62.6 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M62.3 114.4L43.2 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M71.5 114.4L90.6 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M90.3 114.4L71.2 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M99.3999 114.4L118.5 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M118.2 114.4L99.2 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M127.4 114.4L146.5 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M155.3 114.4L174.4 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M183.3 114.4L202.4 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M146.2 114.4L127.1 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M174.1 114.4L155 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M202.1 114.4L183 133.5",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M154.7 85.3L173.8 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M173.5 85.3L154.4 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M183.4 85.3L202.4 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M202.2 85.3L183.1 104.4",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M218.8 188.9C218.8 188.9 205.1 203.2 186.7 195.9C168.3 188.6 168.9 171.8 163.5 171.1C158.1 170.5 161.1 183.6 161.1 183.6C160.5 181.2 152.3 180.5 150.5 180.4C145 180.2 141.6 183.8 140.1 189C137.4 198 139 208.1 144.3 215.8C148.2 221.5 154.4 225.3 160.3 228.4C166.9 231.9 173.3 235.3 179.7 239.1C186.5 243.2 193.2 247.3 199.8 251.5C200.5 251.9 208.6 256.3 208.5 257L218.7 188.7L218.8 188.9Z",
				fill: "#1c70e8",
				stroke: "#001321",
				strokeWidth: 4,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M300.3 368.9L295.4 349.8H290.1L284.4 368.9H217.7C217.7 368.9 196.9 329.8 195.7 298.1C195.7 297.1 195.7 296.1 195.7 295.1C195.7 294.8 195.7 294.4 195.7 294.1C195.7 292.4 195.7 290.6 195.8 288.8C196 284.4 196.3 279.5 196.8 274.4C199.5 247.6 206.6 212.5 213.8 183.6C215.9 175.1 218.1 167.2 220.1 160.2C226.3 139 230.1 115.6 243.7 97.6C262.9 72.2 303.6 69.6 328.5 87.7C351 104.1 354.3 135.5 361.5 160.2C363.5 167 365.6 174.7 367.6 183C374.9 212 382.1 247.4 384.8 274.4C385.5 281.7 385.9 288.4 385.9 294.2C385.9 300 385.9 294.9 385.9 295.2C385.9 296.2 385.9 297.2 385.9 298.2C384.7 329.9 363.9 369 363.9 369H300.2L300.3 368.9Z",
				fill: "#1c70e8",
				stroke: "#001321",
				strokeWidth: 4,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M293.2 331.6C292.9 331.6 292.5 331.6 292.2 331.6C280.1 331.3 267.5 326.8 257.6 319.3C243.3 308.4 234.7 291.1 234.7 273.1C234.7 255.1 241 243.3 252.6 232.1C263.7 221.3 278.5 215.2 293.2 215.2C307.9 215.2 306.9 216.5 313.3 219.2C319.3 221.7 324.9 225.1 330.4 228.5C336.2 232.1 342.2 235.8 348.8 238.3C355.8 241 362.6 242.4 369.1 242.4C375.6 242.4 376.2 242 379.5 241.1C380.4 245.3 383.5 261.6 384.3 279.9C384.8 291.5 384.1 302.9 383.7 306.8C378.4 304.8 373.1 303.8 367.7 303.8C352.5 303.8 338.9 311.8 326.2 319.9C316.6 326.1 306 331.8 293.1 331.8L293.2 331.6Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M293.3 216.1C300.1 216.1 306.7 217.4 313 220C318.9 222.4 324.5 225.9 329.9 229.2C335.8 232.8 341.8 236.5 348.5 239.1C355.6 241.9 362.5 243.3 369.2 243.3C375.9 243.3 375.7 242.9 378.8 242.2C379.9 247.6 382.6 262.8 383.4 279.8C383.9 290.2 383.3 300.5 382.9 305.2C377.9 303.4 372.9 302.6 367.8 302.6C352.4 302.6 338.6 310.6 325.8 318.9C316.3 325 305.8 330.6 293.3 330.6C280.8 330.6 292.6 330.6 292.3 330.6C280.4 330.3 268 325.9 258.3 318.5C244.2 307.7 235.8 290.8 235.8 273.1C235.8 255.4 242 243.8 253.4 232.9C264.3 222.3 278.9 216.3 293.4 216.3M293.3 214.1C262.4 214.1 233.8 240.4 233.8 273C233.8 305.6 242.5 308.9 257.1 320C267 327.6 279.8 332.2 292.3 332.5C292.7 332.5 293 332.5 293.4 332.5C305.9 332.5 316.6 327.1 327 320.4C340.2 311.9 353.4 304.4 368 304.4C373.4 304.4 379 305.4 384.9 307.8C384.9 307.8 386.2 293.9 385.6 279.5C384.6 258 380.6 239.5 380.6 239.5C377 240.6 373.2 241 369.5 241C362.7 241 355.9 239.4 349.6 237C336.9 232.1 326.6 223 314.1 217.9C307.3 215.1 300.4 213.9 293.6 213.9L293.3 214.1Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M292.5 197.9C285.9 197.9 279.5 196.8 273.4 194.8C267.7 192.9 262.4 190.1 257.2 187.5C251.7 184.7 246 181.8 239.8 179.8C233.2 177.7 226.7 176.6 220.6 176.6C214.5 176.6 217.9 176.6 216.6 176.8L230.1 128.1C241.4 126.3 252.1 121 261.2 116.1C270.3 111.2 280.4 106.7 292.6 106.7C304.8 106.7 293.3 106.7 293.6 106.7C305.1 106.9 317 110.5 326.4 116.4C339.9 125 348 138.5 348 152.6C348 166.7 342 175.9 331.2 184.6C320.7 193.1 306.6 197.9 292.7 197.9H292.5Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M292.5 105.6V107.6C292.8 107.6 293.1 107.6 293.5 107.6C304.8 107.8 316.6 111.3 325.8 117.2C339 125.6 346.9 138.8 346.9 152.5C346.9 166.2 341.1 175.2 330.4 183.8C320 192.1 306.2 196.9 292.5 196.9C278.8 196.9 279.7 195.9 273.7 193.8C268.1 191.9 262.8 189.2 257.6 186.6C252.1 183.8 246.3 180.8 240 178.8C233.3 176.6 226.7 175.5 220.5 175.5C219.6 175.5 218.7 175.5 217.9 175.5L230.8 128.8C242 126.9 252.5 121.6 261.5 116.8C270.5 112 280.5 107.5 292.4 107.5V105.5M292.5 105.6C280.6 105.6 270.5 109.8 260.7 115.1C250.5 120.6 240.3 125.5 229.3 127.1L215.3 177.8C217.1 177.6 218.8 177.5 220.6 177.5C227 177.5 233.5 178.7 239.5 180.7C251.5 184.6 261.3 191.7 273.1 195.7C279.5 197.9 286.1 198.9 292.5 198.9C321.8 198.9 348.9 178.2 348.9 152.5C348.9 126.8 340.7 124.2 326.9 115.5C317.5 109.5 305.4 105.9 293.6 105.6C293.3 105.6 292.9 105.6 292.6 105.6H292.5Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M321.3 83.3C315.9 80.4 310.2 78.5 304.3 77.4C298.4 76.1 291.8 75.8 286.2 73C282.4 71.1 278.9 67.9 277.3 63.9L277.6 63.7C279.3 65 280.9 66.1 282.5 67C289.4 70.5 297.3 72.8 304.8 74.9C310.7 76.6 316.5 79.3 321.4 83L321.2 83.3H321.3Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M330.5 344.4C308 354.3 278 353.8 255.3 344.4C261.6 345.4 267.9 346.1 274.1 346.7C285.8 347.7 297.6 347.9 309.3 347.1C310.8 347 314.8 346.6 316.3 346.4C320.9 345.9 325.9 345 330.4 344.4H330.5Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M262.5 162.5C272.993 162.5 281.5 153.993 281.5 143.5C281.5 133.007 272.993 124.5 262.5 124.5C252.007 124.5 243.5 133.007 243.5 143.5C243.5 153.993 252.007 162.5 262.5 162.5Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M258.2 157.7C266.319 157.7 272.9 151.119 272.9 143C272.9 134.881 266.319 128.3 258.2 128.3C250.081 128.3 243.5 134.881 243.5 143C243.5 151.119 250.081 157.7 258.2 157.7Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M271.227 137.125C272.359 135.992 271.631 133.428 269.6 131.397C267.57 129.366 265.005 128.638 263.873 129.771C262.74 130.903 263.468 133.468 265.499 135.498C267.53 137.529 270.094 138.257 271.227 137.125Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M319.6 162.5C330.093 162.5 338.6 153.993 338.6 143.5C338.6 133.007 330.093 124.5 319.6 124.5C309.107 124.5 300.6 133.007 300.6 143.5C300.6 153.993 309.107 162.5 319.6 162.5Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M315.7 157.7C323.819 157.7 330.4 151.119 330.4 143C330.4 134.881 323.819 128.3 315.7 128.3C307.581 128.3 301 134.881 301 143C301 151.119 307.581 157.7 315.7 157.7Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M328.685 137.166C329.818 136.033 329.09 133.469 327.059 131.438C325.028 129.408 322.464 128.68 321.331 129.812C320.199 130.945 320.927 133.509 322.958 135.54C324.989 137.57 327.553 138.298 328.685 137.166Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M333.5 107.9L317.5 106.1C315.2 105.8 313.4 104.1 313.1 102L312.6 98C312.4 96.7 314 95.7 315.2 96.4L333.8 106.8C334.4 107.1 334.1 108 333.4 107.9H333.5Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M252.5 107.9L268.5 106.1C270.8 105.8 272.6 104.1 272.9 102L273.4 98C273.6 96.7 272 95.7 270.8 96.4L252.2 106.8C251.6 107.1 251.9 108 252.6 107.9H252.5Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M313.7 368.9H300.3L299.3 365L295.4 349.8L308.9 349.5L313.7 368.9Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M262.4 316.3C243.9 297.7 231 272.7 225.1 247.7C218.8 221.1 224.2 193.4 231.5 167.5C235.6 153 240.2 138.2 244.7 123.7C251 103.8 261.2 84.5 281.6 76.5C266.8 78.5 252.8 85.4 243.7 97.5C230.1 115.5 226.3 139 220.1 160.1C218 167.1 215.9 175 213.8 183.5C206.6 212.4 199.5 247.5 196.8 274.3C196.3 279.5 195.9 284.3 195.8 288.7C195.8 290.5 195.7 292.3 195.7 294C195.7 295.7 195.7 294.7 195.7 295C195.7 296 195.7 297 195.7 298C196.9 329.7 217.7 368.8 217.7 368.8H232.9H284.4L290.1 349.7L325.2 345.8C320 346.4 313 343.7 308.2 342.3C290.8 337.4 275.2 329 262.4 316.1V316.3Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.1 368.9L39.4 368.6L51.7 368.4L76.2 368C92.5 367.8 108.9 367.6 125.2 367.4C141.5 367.2 157.9 367.2 174.2 367.1H223.2C223.2 367 272.2 367.1 272.2 367.1C288.5 367.2 304.9 367.2 321.2 367.4C337.5 367.5 353.9 367.7 370.2 368L394.7 368.5L407 368.7L419.3 369L407 369.3L394.7 369.5L370.2 370C353.9 370.2 337.5 370.4 321.2 370.6C304.9 370.8 288.5 370.8 272.2 370.9H223.2C223.2 371 174.2 370.9 174.2 370.9C157.9 370.8 141.5 370.8 125.2 370.6C108.9 370.5 92.5 370.3 76.2 370L51.7 369.6L39.4 369.4L27.1 369.1V368.9Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M165.4 207.1C164.8 193.6 204.4 226.2 204.4 226.2L200 251.7L155.4 225.6L142.7 214.2C142.7 214.2 165.9 216.8 165.5 207.2L165.4 207.1Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M277 170.5C284.9 175.4 290.7 176 299 172.1C303 170.1 302.9 170 300.2 173.7C293.3 181.3 281.2 180.2 277 170.6V170.5Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.346 140.226L147.123 142.556L161.417 235.968L176.64 233.639L162.346 140.226Z",
				fill: "#83ce63",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.199 140.234L146.976 142.563L148.065 149.68L163.288 147.351L162.199 140.234Z",
				fill: "#1c70e8",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M175.5 226.529L160.277 228.859L161.366 235.976L176.589 233.646L175.5 226.529Z",
				fill: "#1c70e8",
				stroke: "#001321",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.9 116.4L145.8 141.8L163.3 139.1L150.9 116.4Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.1 180.7C158.4 180.1 158.7 183.6 161.5 197.2C164.4 210.9 151.7 212.4 151.7 212.4",
				fill: "#1c70e8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M149.9 178.7C155.1 178 158.9 179.5 160.8 184.7C162.1 188.4 162.7 191.9 163.4 195.6C164.2 199.6 164.3 203.9 162.1 207.6C160 211.2 155.8 213.4 151.7 212.5V212.3C158.9 208 161.3 204.4 159.2 196.5C158.2 192.6 157.7 188.6 156.2 185.2C156 184.7 155.6 184.1 155.2 183.7C154 182.7 152.4 182.7 150.3 182.7L150 178.7H149.9Z",
				fill: "#001321"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_252_2411",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 419.4,
			height: 370.9,
			fill: "white"
		})
	}) })]
});
export default SvgBrandheroWorkspaceDark;
